module.exports = __webpack_public_path__ + "static/media/etherscan-logo.0cb879a7.svg";